import React from 'react'
import {FaCoins} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import './Navbar.css'
import img from '../assets/navlogo.png'

const Navbar = () => {
    return (
        <Link to='/'>
            <div className='navbar'>
                
                <h1> <img className={'navbar-logo'} src={img} width={250} height={250}/></h1>
            </div>
        </Link>
    )
}

export default Navbar
